/*** IMPORTS FROM imports-loader ***/
var define = false;

export function initCountUp() {
  var elements = document.querySelectorAll('[data-count-to]');
  if (!elements.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateCount(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  elements.forEach(function (el) {
    if (prefersReducedMotion) {
      // Show final value immediately
      return;
    }
    // Store original text, show empty until animated
    el.setAttribute('data-count-original', el.textContent);
    el.textContent = el.getAttribute('data-count-prefix') || '';
    observer.observe(el);
  });

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count-to'));
    var prefix = el.getAttribute('data-count-prefix') || '';
    var suffix = el.getAttribute('data-count-suffix') || '';
    var duration = 2500;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);

      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target);

      el.textContent = prefix + current.toLocaleString() + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }
}

